import { ENDPOINT_ATTACHMENT_DOWNLOAD_URL } from '../config'
import type { GetDownloadUrlResInterface } from '../types'
import type { AxiosResponse } from 'axios'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Get a presigned download URL for an attachment
 */
const getDownloadUrl = async (
  workspaceId: string,
  attachmentId: string,
  expiresInSeconds: number = 3600,
): Promise<GetDownloadUrlResInterface> => {
  const endpoint = `${ENDPOINT_ATTACHMENT_DOWNLOAD_URL(workspaceId, attachmentId)}?expiresInSeconds=${expiresInSeconds}`

  const response: AxiosResponse<GetDownloadUrlResInterface> =
    await AuthAxios.get(endpoint)

  return response.data
}

export default getDownloadUrl
